import { all, call, put, takeEvery } from 'redux-saga/effects'
import forgotPasswordActions from './forgotPasswordActions'
import forgotPasswordTypes from './forgotPasswordTypes'
import ForgotPasswordServices from '../../services/ForgotPasswordService'
import notificationActions from '../notifications/notificationActions'

function * sendForgotPasswordEmail ({ payload }) {
  try {
    yield call(ForgotPasswordServices.forgotPassword, payload)
    yield put(forgotPasswordActions.sendForgotPasswordEmailResponse())
    yield put(notificationActions.SendToast({ message: 'We\'ve just sent you an email to reset your password.', type: 'success' }))
  } catch ({ message }) {
    yield put(forgotPasswordActions.sendForgotPasswordEmailResponse())
    yield put(notificationActions.SendToast({ message, type: 'error' }))
  }
}

export function * onSendForgotPasswordEmail () {
  yield takeEvery(forgotPasswordTypes.SEND_FORGOT_PASSWORD_EMAIL, sendForgotPasswordEmail)
}

export function * forgotPasswordSaga () {
  yield all([
    call(onSendForgotPasswordEmail)
  ])
}
